// extracted by mini-css-extract-plugin
module.exports = {"loader_container":"styles_loader_container__18DfO"};